export default "__VITE_ASSET__3Bb93naz__"